module.exports = __webpack_public_path__ + "img/poiz_bedok_south.89e95033.jpg";